import React from 'react';
import { render } from 'react-dom';
import Carousel from '.';
import { canAutoplay } from './canAutoPlay';

export const initDealsCarousel = (heroDeals) => {
  try {
    if (!Array.isArray(heroDeals)) {
      throw new TypeError('heroDeals must be an array');
    }

    const carouselContainer = document.querySelector('[data-deals-carousel]');
    if (!carouselContainer) {
      throw new Error('No container was available to render the Carousel');
    }

    render(<Carousel slides={heroDeals} autoplay={canAutoplay()} type="deals" />, carouselContainer);
  } catch (e) {
    console.error(e);
  }
};
